<template>
   <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="filemodalOpen" :class="{show: filemodalOpen}" >
   <div class="cstm-modal medium fixed_medium">
      <div class="header">
          <h4>{{ fileType }}</h4>
          <button @click.stop="closePopupFileModal" class="close-modal">&times;</button>
        </div>
         <div class="p-4">
      <div class="flex flex-wrap justify-between items-center mb-2">
        <h5>{{ fileType }} List</h5>
        <!-- <vs-button @click="addVideoForm = true">Add New</vs-button> -->

        <vs-tooltip text="Add New" color="primary">
          <vs-button
            type="border"
            color="primary"
            icon="add"
            @click="addVideoForm = true"
          />
        </vs-tooltip>
      </div>
      <div
        style="max-height: 200px; overflow: auto"
        class="vertical_scrollbar border_btm pb-4"
        @scroll="detectsScrollLength()"
        ref="element"
      >
        <vs-table
          style="max-height: 200px"
          class="cstm_vuexy_table vertical_scrollbar"
         
          :data="topic_list"
        >
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th style="width: 150px;">{{ fileType }}</vs-th>
            <vs-th>Title</vs-th>
            <vs-th>Description</vs-th>
          </template>

          <template slot-scope="{ data }">

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <input type="radio" name="picked" class="cursor-pointer" @click = "selectFile(data[indextr])" />
            </vs-td>
              <vs-td :data="data[indextr].topicFiles">
                <div v-if="data[indextr].topicFiles[0]">
                  <template v-if="fileType == 'Video'">
                    <video width="150" height="75" controls>
                      <source :src="data[indextr].topicFiles[0].file.file_path">
                    </video>
                  </template>
                  <template v-if="fileType == 'Audio'">
                    <audio width="300" height="150" controls>
                      <source :src="data[indextr].topicFiles[0].file.file_path">
                    </audio>
                  </template>
                  <template v-if="fileType == 'File'">
                   <div style="width:50px">
                  <pdf :src="data[indextr].topicFiles[0].file.file_path"></pdf>
                </div>
                  </template>
                </div>

                <div v-else>No {{fileType}} Available</div>
              </vs-td>
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td :data="data[indextr].description">
                {{ data[indextr].description }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-button class="block mx-auto mt-4" @click="exportToCourse">Export to Coursebuilder</vs-button>
<div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="addVideoForm" :class="{show: addVideoForm}">
   <div class="cstm-modal medium fixed_medium">
       <div class="header">
          <h4>{{ fileType }}</h4>
          <button @click.stop="addVideoForm=false" class="close-modal">&times;</button>
        </div>
             <form class="video_form border_btm vertical_scrollbar p-4" style="max-height: calc(100vh - 100px); overflow-x: hidden; overflow-y: auto;">
          <div class="each_detail mb-4">
            <label>{{ fileType }} title</label>
            <vs-input
              v-model="contentPayload.name"
              class="w-full"
              type="text"
              :placeholder="`Enter ${fileType} title here `"
            />
          </div>
          <div class="each_detail mb-4">
            <label>{{ fileType }} description</label>
            <vs-textarea
              v-model="contentPayload.description"
              class="w-full mb-0"
              :placeholder="`Enter ${fileType} description here `"
            ></vs-textarea>
          </div>
          <div class="each_detail mb-4">
            <label>Insert {{ fileType }} link</label>
            <div class="w-full">
              <vs-input
                v-model="file_link"
                class="w-full"
                type="text"
                :placeholder="`Enter your ${fileType} link here `"
              />
              <p class="text-center my-4">Or</p>
              <div
                style="max-width: 200px; height: 50px; margin: 0 auto;"
                class="image_preview_holder"
                v-if="fileType == 'Video'"
              >
                <div
                  class="
                    flex
                    justify-center
                    items-center
                    w-full
                    h-full
                  "
                >
                  <span style="font-size: 30px" class="material-icons-outlined"
                    >videocam</span
                  >
                  <h6 style="color: #808080" class="m-2">Browse Video</h6>
                </div>
                <input
                  type="file"
                  accept="video/mp4,video/x-m4v,video/*"
                  @change="previewVideo"
                />
              </div>
              <template v-if="fileType == 'Video' && preview_video">
                <h4 class="text-center my-4">Preview</h4>
                <video style="display: block; width: 600px; margin: 10px auto;" controls>
                  <source :src="preview_video">                  
                </video>
              </template>
              <div
                style="max-width: 200px; height: 50px; margin: 0 auto;"
                class="image_preview_holder"
                v-else-if="fileType == 'Audio'"
              >
                <div
                  class="
                    flex
                    justify-center
                    items-center
                    w-full
                    h-full
                  "
                >
                  <span style="font-size: 30px" class="material-icons-outlined"
                    >mic_none</span
                  >
                  <h6 style="color: #808080" class="m-2">
                    Browse {{ fileType }}
                  </h6>
                </div>
                <input type="file" accept="audio/*" @change="previewVideo" />
              </div>
              <template v-if="fileType == 'Audio' && preview_video">
                <h4 class="text-center my-4">Preview</h4>
                <audio style="display: block; margin: 10px auto;" controls>
                  <source :src="preview_video">
                </audio>
              </template>
              <div
                style="max-width: 200px; height: 50px; margin: 0 auto;"
                class="image_preview_holder"
                v-else-if="fileType == 'File'"
              >
                <div
                  class="
                    flex
                    justify-center
                    items-center
                    w-full
                    h-full
                  "
                >
                  <span style="font-size: 30px" class="material-icons-outlined"
                    >folder_special</span
                  >
                  <h6 style="color: #808080" class="m-2">
                    Browse {{ fileType }}
                  </h6>
                </div>
                <input type="file" accept="application/pdf" @change="previewVideo" />
              </div>
              <template v-if="fileType == 'File' && preview_video">
                <h4 class="text-center my-4">Preview</h4>
                <!-- <div style="word-break: break-all;">{{ preview_video }}</div> -->
                <div style="width:400px; margin: 10px auto;">
                  <pdf :src="preview_video"></pdf>
                </div>
                 
              </template>
            </div>
          </div>
           <vs-button class="block mx-auto mt-4" @click="createTopic()"
          >Save</vs-button
        >
        </form>
       
   </div>
   </div>
      </div>
   </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
import { repository } from '@/mixins/repository'
import { UploadImage } from '@/api/common'
import { addFile } from '@/api/file'
export default {
  mixins: [repository],
  name: 'FileModalComponent',
  props: {
    filemodalOpen: {
      default: false
    },
    fileType: {
      default: ''
    },
    topic_list: {
      default: []
    }
  },
  created () {
    this.getRepositoryId(3)
  },
  components: {
    pdf
  },
  data () {
    return {
      selected: '',
      file_link: null,
      customer_id: localStorage.getItem('customer_id'),
      preview_video: null,
      addVideoForm: false,
      contentPayload: {
        name: null,
        description: null,
        custom: 0,
        has_all_subject: false,
        status: true,
        is_visible: true,
        topic_type: null,
        files: null
      }
    }
  },
  methods: {
    selectFile (data) {
      this.selected = data
    },
    detectsScrollLength () {
      if (Math.ceil(this.$refs.element.scrollTop + this.$refs.element.offsetHeight) >= this.$refs.element.scrollHeight) {
        this.$emit('loadMoreTopic', this.fileType)
      }
    },
    closePopupFileModal () {
      this.$emit('closePopupFileModal', true)
    },
    exportToCourse () {
      this.$emit('exportToCourse', this.selected)
    },
    createTopic () {
      if (this.file_link) {
        this.getFileId()
      } else {
        if (this.fileType === 'Video') {
          this.contentPayload.topic_type = 1
        } else if (this.fileType === 'Audio') {
          this.contentPayload.topic_type = 2
        } else if (this.fileType === 'File') {
          this.contentPayload.topic_type = 5
        }
        this.addVideoForm = false

        this.$emit('createTopic', this.contentPayload)
        this.setDefault()
      }
    },
    setDefault () {
      this.contentPayload.name = null
      this.contentPayload.description = null
      this.contentPayload.custom = 0
      this.contentPayload.has_all_subject = false
      this.contentPayload.status = false
      this.contentPayload.is_visible = false
      this.contentPayload.topic_type = null
      this.contentPayload.files = null
      this.preview_video = null
    },
    async previewVideo (event) {
      const input = event.target
      if (input.files) {
        const reader = new FileReader()
        reader.onload = e => {
          this.preview_video = e.target.result
        }
        this.video = input.files[0]
        reader.readAsDataURL(input.files[0])

        const formData = new FormData()
        formData.append('files[]', input.files[0])

        const data = await UploadImage(formData, this.customer_id)
        const cdn = data.data.data.cdn

        const file_name = data.data.data.files[0].file_name
        const file_path = data.data.data.files[0].file_path

        const raw = JSON.stringify({
          file_repository_id: this.repository_id,
          files: [
            {
              file_name,
              file_path: `${cdn}${file_path}`
            }
          ]
        })

        const file_id_payload = raw

        this.getUploadFiles(file_id_payload)
      }
    },
    async getUploadFiles (file_id_payload) {
      const res = await addFile(file_id_payload)

      this.contentPayload.files = res.data.data.files[0].files_id
      if (this.file_link) {
        this.file_link = null
        this.createTopic()
      }
      this.$vs.loading.close()
    },
    async getFileId () {
      const file_name = new Date()
      const file_path = this.file_link

      const raw = JSON.stringify({
        file_repository_id: this.repository_id,
        files: [
          {
            file_name,
            file_path
          }
        ]
      })

      const file_id_payload = raw

      this.getUploadFiles(file_id_payload, 'video')
    }
  }
}
</script>
